import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import React from "react";
import { TokenTagProps } from "./TokenTag.props";
import './TokenTag.styles.css'

const TokenTag: React.FC<TokenTagProps> = ({ token, clickHandler, tooltip, expandable }) => {
  return (
    <Tooltip
      title={tooltip}
      placement="top-start"
      onClick={() => clickHandler(token)}
      data-testid="tokenTag"
    >
      <Box
        className={`token-tag-container ${expandable && 'tag-expandable'}`}
        onClick={() => clickHandler(token)}
        onMouseDown={(event: any) => event.preventDefault()}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="body2" fontWeight={500}>{token}</Typography>
          <InfoOutlined/>
        </Stack>
      </Box>
    </Tooltip>
  )
};

export default TokenTag;